const HomePage = () => {
    return <div className="flex justify-content-center align-items-center pt-8">
        <h1>Вітаємо у RCT CRM системі!</h1>
        </div>
}

export default HomePage;